module.exports = [{
      plugin: require('C:/Users/vvalliant/Documents/GitHub/fedfunds/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-TMRP23D","includeInDevelopment":true,"gtmAuth":"SqaRxg0f_r1SEHJc735cxA","gtmPreview":"env-2"},
    },{
      plugin: require('C:/Users/vvalliant/Documents/GitHub/fedfunds/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/vvalliant/Documents/GitHub/fedfunds/budgets/fedfunds/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
